// Import action type from an external file
import * as actionTypes from "../Actions/ActionTypes";

// Define the initial state for the Redux store
const initialState = {
  error: false,
  userData: null,
  message: "",
  loading: false,
  exp: null,
};

// Define a Redux reducer function
const store = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.ADMIN_LOGIN_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload.data[0],
        message: action.payload?.message || "",
        error: false,
        exp: action.payload?.exp,
      };
    case actionTypes.ADMIN_LOGIN_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case actionTypes.ADMIN_LOGOUT_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.ADMIN_LOGOUT_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: null,
      };
    case actionTypes.ADMIN_LOGOUT_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case actionTypes.GET_USER_PROFILE_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.GET_USER_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
      };
    case actionTypes.GET_USER_PROFILE_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
        message: action.payload,
      };
    case actionTypes.UPDATE_PROFILE_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.UPDATE_PROFILE_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: action.payload,
      };
    case actionTypes.UPDATE_PROFILE_FAILED:
      return {
        ...state,
        loading: false,
        error: true,
      };
    case actionTypes.UPDATE_PROFILE_PIC_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.UPDATE_PROFILE_PIC_SUCCESS:
      return {
        ...state,
        loading: false,
        userData: {
          ...state.userData,
          profile_pic: action.payload,
        },
      };
    case actionTypes.UPDATE_PROFILE_PIC_FAILED:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.FORGOT_PASSWORD_INIT:
      return {
        ...state,
        loading: true,
      };
    case actionTypes.FORGOT_PASSWORD_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case actionTypes.FORGOT_PASSWORD_FAILED:
      return {
        ...state,
        loading: false,
      };
    default:
      return state;
  }
};

export default store;
